import BasePresenter from "../../redare/presenter/BasePresenter";
import * as UserApplicationHttp from "../http/UserApplicationHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class UserApplicationPresenter extends BasePresenter {

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findUserApplicationPage(body, query, success, fails) {

        if (this._onBeforeFindUserApplicationPage) {
            let data = this._onBeforeFindUserApplicationPage(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.findUserApplicationPage(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindUserApplicationPageSuccess) {
                    result = this._onBeforeFindUserApplicationPageSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindUserApplicationPageSuccess) {
                    this.view._onFindUserApplicationPageSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findUserApplicationPageList(body, query, success, fails) {

        if (this._onBeforeFindUserApplicationPageList) {
            let data = this._onBeforeFindUserApplicationPageList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.findUserApplicationPageList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindUserApplicationPageListSuccess) {
                    result = this._onBeforeFindUserApplicationPageListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindUserApplicationPageListSuccess) {
                    this.view._onFindUserApplicationPageListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {}
     * @returns Promise
     */
    finUserApplicationList(body, query, success, fails) {

        if (this._onBeforeFinUserApplicationList) {
            let data = this._onBeforeFinUserApplicationList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.finUserApplicationList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFinUserApplicationListSuccess) {
                    result = this._onBeforeFinUserApplicationListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFinUserApplicationListSuccess) {
                    this.view._onFinUserApplicationListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    getUserApplication(body, query, success, fails) {

        if (this._onBeforeGetUserApplication) {
            let data = this._onBeforeGetUserApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.getUserApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetUserApplicationSuccess) {
                    result = this._onBeforeGetUserApplicationSuccess(result, {body, query});
                }

                if (this.view && this.view._onGetUserApplicationSuccess) {
                    this.view._onGetUserApplicationSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {userId, applicationId, applicationUserId, applicationUserPwd, status, createTime, sort, accountId, pcOrMobile}
     * @param query: {}
     * @returns Promise
     */
    addUserApplication(body, query, success, fails) {

        if (this._onBeforeAddUserApplication) {
            let data = this._onBeforeAddUserApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.addUserApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeAddUserApplicationSuccess) {
                    result = this._onBeforeAddUserApplicationSuccess(result, {body, query});
                }

                if (this.view && this.view._onAddUserApplicationSuccess) {
                    this.view._onAddUserApplicationSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, userId, applicationId, applicationUserId, applicationUserPwd, status, createTime, sort, accountId, pcOrMobile, diff}
     * @param query: {}
     * @returns Promise
     */
    editUserApplication(body, query, success, fails) {

        if (this._onBeforeEditUserApplication) {
            let data = this._onBeforeEditUserApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.editUserApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeEditUserApplicationSuccess) {
                    result = this._onBeforeEditUserApplicationSuccess(result, {body, query});
                }

                if (this.view && this.view._onEditUserApplicationSuccess) {
                    this.view._onEditUserApplicationSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    deleteUserApplication(body, query, success, fails) {

        if (this._onBeforeDeleteUserApplication) {
            let data = this._onBeforeDeleteUserApplication(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.deleteUserApplication(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeDeleteUserApplicationSuccess) {
                    result = this._onBeforeDeleteUserApplicationSuccess(result, {body, query});
                }

                if (this.view && this.view._onDeleteUserApplicationSuccess) {
                    this.view._onDeleteUserApplicationSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {}
     * @returns Promise
     */
    findUserApplicationMap(body, query, success, fails) {

        if (this._onBeforeFindUserApplicationMap) {
            let data = this._onBeforeFindUserApplicationMap(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.findUserApplicationMap(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindUserApplicationMapSuccess) {
                    result = this._onBeforeFindUserApplicationMapSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindUserApplicationMapSuccess) {
                    this.view._onFindUserApplicationMapSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, applicationUserId, applicationUserPwd}
     * @param query: {}
     * @returns Promise
     */
    modifyUserAndPassword(body, query, success, fails) {

        if (this._onBeforeModifyUserAndPassword) {
            let data = this._onBeforeModifyUserAndPassword(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.modifyUserAndPassword(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeModifyUserAndPasswordSuccess) {
                    result = this._onBeforeModifyUserAndPasswordSuccess(result, {body, query});
                }

                if (this.view && this.view._onModifyUserAndPasswordSuccess) {
                    this.view._onModifyUserAndPasswordSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id}
     * @param query: {}
     * @returns Promise
     */
    checkUserAndPassword(body, query, success, fails) {

        if (this._onBeforeCheckUserAndPassword) {
            let data = this._onBeforeCheckUserAndPassword(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.checkUserAndPassword(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeCheckUserAndPasswordSuccess) {
                    result = this._onBeforeCheckUserAndPasswordSuccess(result, {body, query});
                }

                if (this.view && this.view._onCheckUserAndPasswordSuccess) {
                    this.view._onCheckUserAndPasswordSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, status}
     * @param query: {}
     * @returns Promise
     */
    modifyStatus(body, query, success, fails) {

        if (this._onBeforeModifyStatus) {
            let data = this._onBeforeModifyStatus(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.modifyStatus(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeModifyStatusSuccess) {
                    result = this._onBeforeModifyStatusSuccess(result, {body, query});
                }

                if (this.view && this.view._onModifyStatusSuccess) {
                    this.view._onModifyStatusSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {}
     * @returns Promise
     */
    findByUserAndAppId(body, query, success, fails) {

        if (this._onBeforeFindByUserAndAppId) {
            let data = this._onBeforeFindByUserAndAppId(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.findByUserAndAppId(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindByUserAndAppIdSuccess) {
                    result = this._onBeforeFindByUserAndAppIdSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindByUserAndAppIdSuccess) {
                    this.view._onFindByUserAndAppIdSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
     * @param query: {}
     * @returns Promise
     */
    realNameAuth(body, query, success, fails) {

        if (this._onBeforeFindByUserAndAppId) {
            let data = this._onBeforeFindByUserAndAppId(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        UserApplicationHttp.realNameAuth(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    console.log(10086);
                    success(result);
                    return;
                }

                if (this._onBeforeFindByUserAndAppIdSuccess) {
                    result = this._onBeforeFindByUserAndAppIdSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindByUserAndAppIdSuccess) {
                    this.view._onFindByUserAndAppIdSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}